import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  PreloadAllModules,
  provideRouter,
  TitleStrategy,
  UrlSerializer,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import {
  tuiDateFormatProvider,
  tuiDialogOptionsProvider,
} from '@taiga-ui/core';
import { NG_EVENT_PLUGINS } from '@taiga-ui/event-plugins';
import { TUI_VALIDATION_ERRORS } from '@taiga-ui/kit';
import {
  provideTanStackQuery,
  QueryClient,
} from '@tanstack/angular-query-experimental';
import {
  ErrorHandlerService,
  TitleStrategyService,
  TrailingSlashUrlSerializer,
} from './core';
import { routes } from './routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideAnimationsAsync(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService,
    },
    {
      provide: TitleStrategy,
      useClass: TitleStrategyService,
    },
    { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer },
    importProvidersFrom(),
    NG_EVENT_PLUGINS,
    tuiDateFormatProvider({ mode: 'MDY', separator: '/' }),
    tuiDialogOptionsProvider({ dismissible: false, size: 'l' }),
    provideTanStackQuery(
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
            throwOnError: true,
          },
        },
      }),
    ),
    provideClientHydration(),
    {
      provide: TUI_VALIDATION_ERRORS,
      useValue: {
        required: 'This field is required.',
        email: 'Invalid email.',
        maxlength: ({ requiredLength }: { requiredLength: string }) =>
          `The maximum length is ${requiredLength}.`,
        minlength: ({ requiredLength }: { requiredLength: string }) =>
          `The minimum length is ${requiredLength}.`,
        pattern: 'Invalid value.',
      },
    },
  ],
};
